import styled from "styled-components";

import { StickyBarPage } from "../../../../../../components/SaveBar";

/* At least one screen tall, so the sticky save bar sits at the bottom */
export const Container = styled(StickyBarPage)``;

type ContainerProps = {
  hide: boolean;
  /** Forced player height (px) for providers with a compact format; others keep their own. */
  $compactHeight?: string;
};

export const PlayerContainer = styled.div<ContainerProps>`
  margin-top: 1rem;
  display: ${props => props.hide && "none"};

  iframe {
    border-radius: 8px;

    ${props => props.$compactHeight && `height: ${props.$compactHeight}px !important;`}
  }
`;

export const PreviewContainer = styled.div`
  width: 100%;
  height: 150px;
  border: 2px dashed var(--color-neutral-light);
  box-sizing: border-box;
  border-radius: 8px;
  margin-top: 1rem;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
